/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DealVolumeResponse { 
    Id?: string;
    Volume?: number;
    PriceLowerThresholdInEuro?: number;
    PriceUpperThresholdInEuro?: number;
    /**
     * A Date Time representation with zone information
     */
    From?: string;
    /**
     * A Date Time representation with zone information
     */
    Until?: string;
}

